<template>
    <div >
      <template v-if="$route.name === 'scoringSetList'">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->         
        <div class="searchCon">
          <div class="searchMain"> 
            <ots-refer
                :selectList="selectList"
                :request-form="requestForm"
                @search="getResult"
            />  
          </div>
        </div>
        <!-- 列表 -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableOption="tableOption"
            :tableData="tableData"
            :batchOperBtn="batchOperBtn"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>  
      </template>
      <template v-else>
        <router-view></router-view>
      </template>
    </div>
</template>


<script>
import {   
    getSelectPlanFn,
    getPlanCourseFn,
    getSubCourseListFn,
    scoredRuleListFn,
    scoredRuleListExportFn,
    confirmScoredRuleByPlanIdFn,
    resetScoredRuleByPlanIdFn
} from '@/http/modules/examSet/scoringSetList';


export default {
  name: "scoringSetList",
  data() {
    return {
        
      mainTopBtnList: [  
        {
          title: "导出",
          fn: this.exportExcel
        }
      ],
      tableHeader: [
        {
          title: "课程名称",
          prop: "courseName",
        },
        {
          title: "单科名称",
          prop: "courseNameSub",
        },
        {
          title: "成绩计算方式",
          prop: "scoreCalculateTypeName",
        },
        {
          title: "赋分人数",
          prop: "scoredStudentCount",
        },
        {
          title: "原始分区间",
          formatter:(scope)=>{
            return scope.row.oriScoreRange.replace(/、/g, "<br>");
          },
          width: "200"
        },
        {
          title: "赋分区间",
          formatter:(scope)=>{
            return scope.row.scoredRange.replace(/、/g, "<br>");
          },
          width: "200"
        },
        {
          title: "等级人数",
          formatter:(scope)=>{
            return scope.row.gradeStudentCount.replace(/、/g, "<br>");
          },
          width: "200"
        },   
        {
            title:"操作",
            type:"buttons",
            width:"140",
            btnList:[
                {
                    title:"赋分规则设置",
                    click: this.scoringRuleSet,
                    disableFn : (val) => val.row.scoreCalculateType == 1
                },
            ]
        }
      ],
      tableData: [],
      pagination: {
        total: 0
      },
      tableListParams: {
        orders: '',
        page: 1,
        size: 10
      },
      selectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "课程名称",
          type: "select",
          multiple: false,
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        }, 
        {
          title: "单科名称",
          type: "select",
          multiple: false,
          requestKey: "courseIdSub",
          label: "subCourseName",
          value: "subCourseId",
          data: [],
        }, 
        {
          title: "赋分状态",
          type: "select",
          multiple: false,
          requestKey: "scoredFlag",
          label: "name",
          value: "id",
          data: [
            {
              name: "全部",
              id: -1,
            },
            {
              name: "未赋分",
              id: 0,
            },
            {
              name: "已赋分未确认",
              id: 1,
            },
            {
              name: "已赋分已确认",
              id: 2,
            },
          ],
        },
      ],

      requestForm: {
        planId: null,
        courseId: null,
        courseIdSub: null,
        scoredFlag: "",
      },

      tableOption: { border: true }, // 示例配置，根据实际需求调整
      batchOperBtn: [
        {
          title: "赋分结果确认",
          click: this.confirmScoredRuleByPlanId,
        },
        {
          title: "赋分规则初始化",
          click: this.resetScoredRuleByPlanId,
        },
      ] // 如果有批量操作需求，请在此配置按钮
    }
  },
  created() { 
    this.initData();
  },
  methods: {
    /*********************************
     * @initData 初始化数据
     ********************************/
    async initData() {
      let { data } = await getSelectPlanFn({ needAudit: 6 });
      this.$set(this.selectList[0], "data", data);
      if (data.length) {
        this.requestForm.planId = data[0].id;
        //this.initCourseList(data[0].id);
      };
    },  
    
    /*********************************
     * @initCourseList 课程随着批次变化
     ********************************/
    async initCourseList(val) {
      this.requestForm.courseId = null;
      const { data: courseData } = await getPlanCourseFn({ planId: val });
      this.selectList[1].data = courseData;
      if(courseData.length) {
        //this.requestForm.courseId = courseData[0].courseId;
        //this.initCourseSubList(val ,courseData[0].courseId);
      }      
    },
 
    /*********************************
     * @initCourseSubList 单科随着综合课程变化
     ********************************/
    async initCourseSubList(val1 ,val2) {
      this.requestForm.courseIdSub = null;
      const { data: subCourseData } = await getSubCourseListFn({ planId: val1 , courseId: val2 });
      this.selectList[2].data = subCourseData;
      if(subCourseData.length) {
        //this.requestForm.courseIdSub = subCourseData[0].subCourseId;
      }       
    },   
  
    
    /*********************************
     * @getResult  获取列表数据
     ********************************/
    async getResult() {
      this.tableListParams = Object.assign(this.tableListParams, this.requestForm);
      const { data } = await scoredRuleListFn(this.tableListParams);
      this.tableData = data.records;
      this.pagination.total = data.total
    },

    changeSize(num) {
        this.tableListParams.size=num
        this.getResult()
    },
    changePage(p) {
        this.tableListParams.page=p
        this.getResult()
    },
    
    /*********************************
     * @getResult  导出
     ********************************/
    async exportExcel() {
      let params = {...this.requestForm}
      const { data, code } = await scoredRuleListExportFn(params);
      if (code) {
        window.open(data);
      }
    },
    
    /*********************************
     * @getResult  赋分结果确认（整批次）
     ********************************/
    async confirmScoredRuleByPlanId() {
      //首先询问，是否要确认
      this.$confirm("是否要确认该批次下的所有赋分结果？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const params = {
            planId: this.requestForm.planId
          }
          const { data, code } = await confirmScoredRuleByPlanIdFn(params);
          if( code ) {
            this.$message.success("赋分结果确认成功");
          }
        })      
    },
    
    /*********************************
     * @getResult  赋分结果初始化（整批次）
     ********************************/
    async resetScoredRuleByPlanId() {
      //首先询问，是否要初始化
      this.$confirm("是否要初始化该批次下的所有赋分结果？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const params = {
            planId: this.requestForm.planId
          }
          const { data, code } = await resetScoredRuleByPlanIdFn(params);
          if( code ) {
            this.$message.success("赋分结果初始化成功");
          }
        })      
    },

    scoringRuleSet(row) {
      this.$router.push({
        path: "/scoringSetList/scoringRuleSet",
        query: {
          setId: row.setId,
        },
      });
    },
  },

  watch: {
    /******************************
     * @this 批次切换，更新课程
     *****************************/
    "requestForm.planId"(val) {
      this.initCourseList(val);
      this.initCourseSubList(val,"");
    },

    /******************************
     * @this 课程切换，更新单科名称
     *****************************/
    "requestForm.courseId"(val) {
      this.initCourseSubList(this.requestForm.planId,val);
    },
  }
}
</script>


<style  lang="less"  scoped>

</style>

